class SlideShowComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.slider');
      this.slides = this.querySelectorAll('.slider__slide');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.currentSlide = 0;
      this.autoRotate = this.slider?.dataset.autoplay === 'true';
      this.speed = parseInt(this.slider?.dataset.speed || '5') * 1000;
      this.intervalId = null;
  
      this.init();
    }
  
    init() {
      if (this.slides.length <= 1) return;
  
      // Configurar slides
      this.setupSlides();
  
      // Adicionar event listeners
      this.prevButton?.addEventListener('click', () => this.previousSlide());
      this.nextButton?.addEventListener('click', () => this.nextSlide());
  
      // Iniciar auto-rotação se habilitada
      if (this.autoRotate) {
        this.startAutoRotation();
      }
  
      // Pausar auto-rotação no hover
      this.addEventListener('mouseenter', () => this.pauseAutoRotation());
      this.addEventListener('mouseleave', () => this.resumeAutoRotation());
  
      // Pausar auto-rotação quando tab está inativo
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAutoRotation();
        } else if (this.autoRotate) {
          this.resumeAutoRotation();
        }
      });
    }
  
    setupSlides() {
      this.slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index !== 0 ? 'true' : 'false');
        if (index !== 0) {
          slide.style.display = 'none';
        }
      });
    }
  
    showSlide(index) {
      // Esconder slide atual
      const currentSlideElement = this.slides[this.currentSlide];
      if (currentSlideElement) {
        currentSlideElement.style.display = 'none';
        currentSlideElement.setAttribute('aria-hidden', 'true');
      }
  
      // Mostrar novo slide
      this.currentSlide = index;
      const newSlideElement = this.slides[this.currentSlide];
      if (newSlideElement) {
        newSlideElement.style.display = 'block';
        newSlideElement.setAttribute('aria-hidden', 'false');
      }
  
      // Atualizar aria-live para anunciar mudança
      if (this.slider) {
        this.slider.setAttribute('aria-live', 'polite');
        setTimeout(() => {
          this.slider.setAttribute('aria-live', 'off');
        }, 1000);
      }
    }
  
    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.showSlide(nextIndex);
    }
  
    previousSlide() {
      const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.showSlide(prevIndex);
    }
  
    startAutoRotation() {
      if (this.slides.length <= 1) return;
      
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.speed);
    }
  
    pauseAutoRotation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  
    resumeAutoRotation() {
      if (this.autoRotate && !this.intervalId) {
        this.startAutoRotation();
      }
    }
  
    disconnectedCallback() {
      this.pauseAutoRotation();
    }
  }
  
  // Definir o custom element
  customElements.define('slideshow-component', SlideShowComponent);
  
  // Para compatibilidade com versões mais antigas, também definir SliderComponent
  window.SliderComponent = SlideShowComponent;